var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.5 -0.5 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Undo-Right--Streamline-Solar-Broken",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Undo Right Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.375H5.62500625C4.45673125 4.375 3.87259375 4.375 3.4375 4.62620625c-0.28503125 0.1645625 -0.521725 0.40125625 -0.68629375 0.6862875C2.5 5.74759375 2.5 6.33175 2.5 7.5s0 1.7523749999999998 0.2512 2.1875c0.16456874999999999 0.2850625 0.4012625 0.5217499999999999 0.6862999999999999 0.6863125000000001C3.87259375 10.625 4.45673125 10.625 5.625 10.625h4.375m2.5 -6.25 -1.875 -1.875m1.875 1.875 -1.875 1.875",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoRight);
export default __webpack_public_path__ + "static/media/Undo-Right.8a64fb4638b69b9ad19e8e70df85ea40.svg";
export { ForwardRef as ReactComponent };